import axios from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContex } from "./../../context API/UserContext";
const Login = () => {
  const [userData, setUserData] = useContext(UserContex);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const handlesubmit = async(e) => {
    e.preventDefault();
    await axios
      .post("https://back.waratechnology.com/api/user/login", {
        email,
        password,
      })
      .then((res) => {
        console.log(res.data);
          const user = res.data.user;
        setUserData({
          token: res.data.token,
          user: res.data.user,
        });
      localStorage.setItem("auth-token", res.data.token);
      localStorage.setItem("user", JSON.stringify(user));
      navigate("/");
      })
      .catch((err) => {
        console.log(err);
        alert("pls try again");
      });
  };
  return (
    <div className=" ">
      <div className="bg-gray-400 flex flex-col justify-center items-center h-screen  ">
        <div className="flex mb-4 items-center">
          <img
            src=""
            alt=""
            className="h-20 w-20 md:h-28 md:w-28 lg:h-32 lg:w-32 border rounded-full mr-4"
          />
          <h2 className="font-bold font-serif italic xl md:2xl lg:text-4xl">
            Wara Technology
          </h2>
        </div>
        <div className="w-3/4 h-2/3 md:w-1/2 md:h-2/3 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
          <div className="flex justify-center mt-2 mb-4">
            <h1 className="uppercase font-bold text-2xl">Login</h1>
          </div>
          <form onSubmit={handlesubmit} className="text-start">
            <label className="mt-4 font-bold">Email</label>
            <input
              placeholder="email"
              type="email"
              className="w-full  pl-2 h-12 md:h-8 mb-4 border border-gray-300 rounded-2xl"
              onChange={(e) => setEmail(e.target.value)}
            />

            <label className="mt-4 font-bold">Password</label>
            <input
              placeholder="password"
              type="password"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setPassword(e.target.value)}
            />

            <div className="flex justify-center mt-4">
              <button
                type=""
                className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-fully"
              >
                login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
